import { ReactElement } from 'react';
import { useEntityPageHeader } from '../../state/EntityPage';
import { FormPageHeaderProps } from '../FormPageHeader';

export interface EntityPageHeaderProps extends FormPageHeaderProps {}

export type EntityPageHeaderElement = ReactElement<
  EntityPageHeaderProps,
  typeof EntityPageHeader
>;

export function EntityPageHeader(_props: EntityPageHeaderProps) {
  return null;
}

EntityPageHeader.useEntityPageHeader = useEntityPageHeader;
EntityPageHeader.displayName = 'EntityPageHeader';
